import di from 'Services/di.js';

export default async ({ messageId }: { messageId: string }) => {
    const { events } = di;

    events.emit('tasks__formAddTask:addNewTask', { type: 'taskByInputMail', messageId });
};
